import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';


export default function LocatorListItemProduct(props){
    //console.debug("RTS Break LocatorListItemProduct");

    return (
        props.data.curAliasName == null
        ?
            <>
            <Typography variant="h6" sx={{color:"Red"}}>No Product Information Available</Typography>
            </> 
        :
            <>
            <Stack>
                <>
                <Tooltip title={props.data.curProductIdSap}>
                    
                    <Typography variant="h6" >
                        {props.data.curAliasName}
                    </Typography>
                </Tooltip>
                <Typography variant="caption" >
                    {props.data.curProductIdSap}
                </Typography>
                </>                                    
            </Stack>
            </>
    );   
}

